/*
 * File: d:\projects\AutoFiFront\src\Content\Home\Engagements\Engagements.tsx
 * Project: d:\projects\AutoFiFront
 * Created Date: Wednesday March 8th 2023
 * Author: Jonathan Mazat
 * -----
 * Last Modified: Monday, 20th November 2023 11:17:42
 * Modified By: Simon (s.gourlet@autobuy.fr>)
 * -----
 * Copyright (c) 2023 Autobuy SAS
 * -----
 * HISTORY:
 */

import Styles from 'Content/Home/TextCardWrapper/TextCardWrapper.module.css';
import TextBox from 'Content/TextBox/TextBox';
import { useNavigate } from 'react-router-dom';
import translator from 'MultiLanguage/TranslationWrapper';
import ButtonAlt from 'Theme/Component/ButtonAlt';
import { IoIosArrowForward } from "react-icons/io";

type TextCardProps = {
    arrowLink: boolean,
    goto?: string,
    itemsArray: {
        title: string,
        text: string,
        icon: JSX.Element,
    }[],
}

function TextCardWrapper(props: TextCardProps){
    const navigate = useNavigate();
    const goto = () => {
        if (props.goto)
            navigate(props.goto);
    };

    return(
        <>
            <div className={`${Styles.cardHolder} ${!props.arrowLink ? "gap-5": ""}`}>
                {
                    props.itemsArray.map((item, index) => { return <div className={`${Styles.boxHolder}`} key={item.title+Math.random()}>
                        <TextBox icon={item.icon} title={item.title} text={item.text} />
                        {
                            props.arrowLink && props.itemsArray.length !== index + 1 ?
                            <IoIosArrowForward className={`${Styles.rotate}`} strokeWidth="1rem" stroke="var(--root-colors-first)" size={"3rem"} fill="var(--root-colors-first)" />
                            : null
                        }
                    </div>})
                }
            </div>
            {
                props.goto ?
                <ButtonAlt className='m-auto' onClick={goto} maxWidth={"50%"}>{translator.decode("aboutUs.knowMore")}</ButtonAlt>
                : null
            }
        </>
    );
}

export default TextCardWrapper;
